import { z } from "zod";
import { ENTITY_NAMES } from "@miplatform/constants";

export const configOrderTemplateSchema = z.object({
  name: z.string().min(1, `${ENTITY_NAMES.ORDER_TEMPLATE} Name is required`),
  shortName: z
    .string()
    .min(1, "Short Name is required")
    .max(8, "Short Name must be at most 8 characters"),
  abbreviation: z
    .string()
    .min(1, "Abbreviation is required")
    .max(3, "Abbreviation must be at most 3 characters"),
  description: z.string().optional(),
  color: z.string().min(1),
  homePhases: z.array(z.string().min(1)),
  tradeId: z.string().uuid(),
  module: z.string().min(1),
  code: z.string().min(1, "Code is required"),
  fields: z.array(
    z.object({
      fieldName: z.string().optional(),
      displayName: z.string().optional(),
      section: z.string().optional(),
      displayOrder: z.number().optional(),
      sectionOrder: z.number().optional(),
      visible: z.boolean().optional(),
      required: z.boolean().optional(),
      componentType: z.string().optional(),
    })
  ),
});

export const emailRecipientSchema = z
  .object({
    type: z.string().optional(),
    relationshipType: z.string().optional(),
    emailAddress: z.string().email().optional().or(z.literal("")),
  })
  .refine((data) => {
    // If type is Contact, relationshipType is required
    if (data.type === "Contact") {
      return !!data.relationshipType;
    }
    // If type is Email, emailAddress is required
    if (data.type === "Email") {
      return !!data.emailAddress;
    }
    return true;
  });

export const emailTemplateSchema = z.object({
  emailType: z.string().optional(),
  replyTo: z.string().email().optional().or(z.literal("")),
  to: z.array(emailRecipientSchema),
  cc: z.array(emailRecipientSchema),
});

export const configEmailTemplateSchema = z.object({
  emailTemplates: z.array(emailTemplateSchema),
});
